import axios from 'axios';

import Logger from '@/Logger';

// Create instance of logger
const logger = new Logger('meStore', 'Actions');

export default {
  getMe({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      try {
        // Get userdata
        const response = await axios.get('me');

        // Log action and status.
        logger.info('getMe', 'Response', response.data);

        const userLang = response.data.user.settings.language;

        await dispatch('getStrings', userLang);

        // Mutate state
        commit('updateMe', response.data.user);

        resolve();
      } catch (error) {
        // Log action and status.
        logger.warn('authLogin', 'Response', { [error.response.status]: error.response.statusText });
        reject();
      }
    });
  },
  clearMe({ commit }) {
    commit('clearMe');
  },
};
